import styled from "styled-components";

export const AgreementPageContentLayout = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  padding: 20px;
  box-sizing: border-box;
`;

export const AgreementPageContentHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  flex-shrink: 0;
  margin-bottom: 20px;
`;

export const AgreementPageContentHeaderTop = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
`;

export const SignUpStepBox = styled.div`
  background: ${(props) => props.theme.colors.primary};
  color: ${(props) => props.theme.colors.white};
  border-radius: 4px;
  padding: 3px 12px;
  font-size: 1.4rem;
  font-weight: 600;
`;

export const SignUpStepTitle = styled.p`
  font-size: 1.6rem;
  font-weight: 600;
  color: ${(props) => props.theme.colors.primary};
`;

export const AgreementPageContentTitle = styled.div`
  font-size: 2rem;
  font-weight: 500;
  white-space: nowrap;

  span {
    width: fit-content;
    font-weight: 700;
    color: ${(props) => props.theme.colors.primary};
  }
`;

export const AgreementPageContentWrap = styled.div`
  flex: 1;
  overflow-y: auto;
  font-size: 1.4rem;
  padding: 20px;
  line-height: 1.6;
  min-height: 0;
`;

export const AgreementPageContentBox = styled.div`
  flex: 0.9;
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-height: 0;
`;

export const AgreementPageConTextBox = styled.div`
  border: 1px solid ${(props) => props.theme.colors.inputBorder};
  border-radius: 6px;
  text-align: justify;
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
`;

export const AgreementPageCheckBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  border-radius: 4px;
  border: 1px solid ${(props) => props.theme.colors.inputBorder};
  color: ${(props) => props.theme.colors.inputBorder};
  font-weight: 600;
  font-size: 1.5rem;
  flex-shrink: 0;
  cursor: pointer;

  &.active {
    border: 1px solid ${(props) => props.theme.colors.primary};
    background: ${(props) => props.theme.colors.primary}0F;
    color: ${(props) => props.theme.colors.primary};
  }
`;

export const ButtomBox = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
  flex-shrink: 0;
  margin-top: 20px;

  .small {
    width: 50%;
  }
`;
